import { PracticeContactViewModel } from 'chaika-types';
import { SimpleList } from '@store/models/SimpleList';

export class PracticeList extends SimpleList<PracticeContactViewModel> {}
